import { convertToCurrency, displayDate } from '../../d3-services/_helpers';
import * as d3 from 'd3';
import { pointer as d3Pointer } from 'd3-selection';
var ChartFocusV2 = /** @class */ (function () {
    function ChartFocusV2(ctrlr) {
        this.ctrlr = ctrlr;
    }
    ChartFocusV2.prototype.draw = function () {
        var div = document.createElement('div');
        div.classList.add("focus-tooltip");
        div.style.border = "1px solid #565656";
        div.style.width = "120px";
        this.ctrlr.element.append(div);
        this.sensePad = this.ctrlr.svg.layers.data.append('rect')
            .style("fill", "none")
            .style("pointer-events", "all");
        this.xLine = this.ctrlr.svg.layers.underData
            .append('g')
            .append('rect')
            .style("fill", "#eee")
            .style("stroke-dasharray", "2 4")
            .style("opacity", 0);
        this.popup = d3.select(this.ctrlr.element).select(' .focus-tooltip')
            .style("opacity", 0)
            .attr("text-anchor", "left");
    };
    ChartFocusV2.prototype.bisect = function (data, x0) {
        var self = this;
        return data.slice.length - 1 - d3.bisect(data.slice.map(function (d) { return d[self.ctrlr.parameters.x]; }).sort(function (a, b) { return a - b; }), x0);
    };
    ChartFocusV2.prototype.redraw = function (data) {
        var self = this;
        // What happens when the mouse move -> show the annotations at the right positions.
        function mouseover() {
            self.xLine.style("opacity", 1);
            self.popup.style("opacity", 1);
        }
        function mousemove(event) {
            var x0 = self.ctrlr.scales.x.scale.invert(d3Pointer(event)[0]);
            // It was not working because d3's bisector function only works on data thats been sorted in ASCENDING order.
            var i = self.bisect(data, x0);
            var j = data.slice.length - i;
            var selectedData = data.slice[j];
            var prevData = (j > 0) ? data.slice[j - 1] : data.slice[0];
            self.xLine
                .attr("x", self.ctrlr.scales.x.scale(new Date(selectedData[self.ctrlr.parameters.x])))
                .attr("width", function () {
                if (self.ctrlr.config.scales.find(function (s) { return s.slug == 'x'; }).type == 'time') {
                    return self.ctrlr.scales.x.scale(new Date(selectedData[self.ctrlr.parameters.x])) - self.ctrlr.scales.x.scale(new Date(prevData[self.ctrlr.parameters.x]));
                }
                else {
                    //   return 1;
                    return self.ctrlr.scales.x.scale(selectedData[self.ctrlr.parameters.x]) - self.ctrlr.scales.x.scale(prevData[self.ctrlr.parameters.x]) - 4;
                }
            })
                .attr("y", 0)
                .attr("height", self.ctrlr.dimensions.height);
            self.popup
                .html(self.html(selectedData, data))
                .style("left", self.ctrlr.scales.x.scale(new Date(selectedData[self.ctrlr.parameters.x])) - 120 + 'px')
                .style("bottom", self.ctrlr.config.margin.bottom + 30 + 'px');
        }
        function mouseout() {
            self.xLine.style("opacity", 0);
            self.popup.style("opacity", 0);
        }
        this.sensePad
            .attr('width', this.ctrlr.dimensions.width)
            .attr('height', this.ctrlr.dimensions.height)
            .on('mouseover', mouseover)
            .on('mousemove', mousemove)
            .on('mouseout', mouseout);
    };
    ChartFocusV2.prototype.html = function (d, data) {
        var self = this;
        var date;
        if (self.ctrlr.config.scales.find(function (s) { return s.slug == 'x'; }).type == 'time') {
            date = displayDate(d[self.ctrlr.parameters.x]);
        }
        else {
            var o = data.slice.find(function (w) { return w[self.ctrlr.parameters.x] == d[self.ctrlr.parameters.x]; });
            date = 'week ' + o._week + '  ' + o._year;
        }
        var html = '<div class="datum"><b>' + date + '</b></div>';
        for (var _i = 0, _a = self.ctrlr.mapping.parameters[0]; _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop.column) {
                case 'maandcijfer':
                    var gem = Math.round(d.maandcijfer * 10) / 10;
                    html = html + '<div class="">' + prop.short + ': ' + gem + '</div>';
                    break;
                case 'waardedaling_maandcijfer': {
                    var wd = (d.waardedaling_maandcijfer > 0) ? d.waardedaling_maandcijfer : "nvt";
                    html = html + '<div class="">' + prop.short + ': ' + wd + '</div>';
                    break;
                }
                case 'fysieke_schade_maandcijfer': {
                    html = html + '<div class="">' + prop.short + ': ' + d.fysieke_schade_maandcijfer + '</div>';
                    break;
                }
                case 'fysieke_schade_week_percentage_toegewezen_besluiten': {
                    html = html + '<div class="">' + prop.short + ': ' + d[prop.column] + '%</div>';
                    break;
                }
                case 'fysieke_schade_gemiddeld_schadebedrag': {
                    html = html + '<div class="">' + prop.short + ': ' + convertToCurrency(d[prop.column]) + '</div>';
                    break;
                }
                default:
                    var value = prop.format === "currency" ? convertToCurrency(d[prop.column]) : d[prop.column];
                    html = html + '<div class="">' + prop.short + ': ' + value + '</div>';
            }
        }
        if (self.ctrlr.mapping.parameters[1]) {
            for (var _b = 0, _c = self.ctrlr.mapping.parameters[1]; _b < _c.length; _b++) {
                var prop = _c[_b];
                html = html + '<div class="">' + prop.short + ': ' + d[prop.column] + '</div>';
            }
        }
        return html;
    };
    return ChartFocusV2;
}());
export default ChartFocusV2;
